module.exports = __webpack_public_path__ + "img/High_cost_performance.ca15678c.jpg";